import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import * as validator from '../../utils/validators/UserValidator';
import { useTranslation } from 'react-i18next';
import useAxiosPrivate from '../../apis/useAxiosPrivate';
import { ValidationError } from 'yup';
// import useAxiosFetchApi from '../../hooks/useFetch';
// import VendorSelect from '../../utils/VendorSelect';
import { useAuth } from '../../hooks/appHooks';

const ADD_VENDOR_USER_INFO_URL = "/vendors/add/user";
const ADD_USER_INFO_URL = "/users/add";
// const FETCH_VENDORS_URL = "/vendors";

const AddOrEditAdminUser = ({ currentUser, onChangeData, isEdit = false, userRole, setShowEditModal = null }) => {
    const { t, i18n } = useTranslation();
    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    // const [state] = useAxiosFetchApi(FETCH_VENDORS_URL.concat("?roleName=VENDOR"), {}, null);
    const [errors, setErrors] = useState({});
    const tUserInfo = t("vendorFormInfo");
    // const vendorList = state.data?.list;

    const handleAddOrEditUser = async (e) => {
        e.preventDefault();
        const form = new FormData(e.target);
        const data = Object.fromEntries(form.entries());
        const userId = isEdit ? currentUser?.userId : null;
        const vendorId = isEdit ? currentUser?.vendor?.vendorId : auth?.vendor?.vendorId;
        const formData = { ...data, role: vendorId ? "VENDOR_USER" : "SUPERADMIN", userId, vendorId };
        try {
            await validator.validationSchema(tUserInfo, t("requiredMessage"))
                .validate(formData, { abortEarly: false });
            setErrors(null);

            const infoResponse = await axiosPrivate.post(userRole === "SUPERADMIN"
                ? ADD_USER_INFO_URL
                : ADD_VENDOR_USER_INFO_URL, formData, {
                headers: { 'Accept-Language': i18n.language }
            });

            onChangeData(infoResponse?.data?.data?.user);
            if (!isEdit) {
                e.target.querySelectorAll('input').forEach(input => {
                    input.value = '';
                });
            }
            toast.success(infoResponse?.data?.data?.message);
            if (setShowEditModal) {
                setShowEditModal({ user: null, status: false })
            }
        } catch (error) {
            if (error instanceof ValidationError) {

                console.log(error instanceof ValidationError ? "validation error..." : error);
                let allErrors = {};
                error.inner.forEach((err) => {
                    allErrors[err.path] = err.message;
                });
                setErrors(allErrors);
            } else {
                if (!isEdit) {
                    e.target.querySelectorAll('input').forEach(input => { input.value = ""; });
                }
                toast.error(error.response?.data?.message || "An error occurred");
                console.error(error);
            }
        }
    };

    return (
        <div className="px-2 py-4 max-w-4xl mx-auto">
            <form className='w-full' onSubmit={handleAddOrEditUser} method='post'>
                <div className="flex flex-col md:flex-row md:flex-wrap md:justify-between gap-4">
                    <div className="w-full md:w-[32%] my-2">
                        <label htmlFor="email" className="text-base md:text-lg mb-1 block">{tUserInfo.email?.label}</label>
                        <input type="email" name="email" id="email" defaultValue={currentUser?.email ?? ''} className="sm:text-sm md:text-base bg-slate-100 rounded-lg w-full p-2.5" placeholder={tUserInfo.email?.placeholder} />
                        {errors?.email && <div className='text-red-600 text-xs md:text-sm mt-1'>{errors.email}</div>}
                    </div>
                    <div className="w-full md:w-[32%] my-2">
                        <label htmlFor="phone" className="text-base md:text-lg mb-1 block">{tUserInfo.phone?.label}</label>
                        <input type="text" name="phone" id="phone" defaultValue={currentUser?.phone ?? ''} className="sm:text-sm md:text-base bg-slate-100 rounded-lg w-full p-2.5" placeholder={tUserInfo.phone?.placeholder} />
                        {errors?.phone && <div className='text-red-600 text-xs md:text-sm mt-1'>{errors.phone}</div>}
                    </div>
                    <div className="w-full md:w-[32%] my-2">
                        <label htmlFor="password" className="text-base md:text-lg mb-1 block">{tUserInfo.password?.label}</label>
                        <input type="password" name="password" id="password" className="sm:text-sm md:text-base bg-slate-100 rounded-lg w-full p-2.5" placeholder={tUserInfo.password?.placeholder} />
                        {errors?.password && <div className='text-red-600 text-xs md:text-sm mt-1'>{errors.password}</div>}
                    </div>
                </div>
                <div className="flex flex-col items-center mt-6">
                    <button type="submit" className="bg-primary-color text-white w-full md:w-1/3 py-2 rounded-lg text-base md:text-lg font-semibold shadow-md">{tUserInfo[isEdit ? "editBtn" : "addBtn"]}</button>
                </div>
            </form>
        </div>
    );
};

export default AddOrEditAdminUser;